let modalBodyPadding = null,
    beforeFreezeScrollPosition = null,
    resizeTimer,
    scrollTimer,
    activeElement,
    lightGallerySettings = {
        autoplay: false,
        autoplayControls: false,
        thumbnail: false,
        download: false,
        share: false,
        fullScreen: false,
        videoMaxWidth: "1140px",
        iframeMaxWidth: "100%",
        enableDrag: true,
        enableTouch: true,
        zoom: false
    };

function checkResolution(query) {
    let active = false;

    if (!query) {
        return true;
    }

    for (let value of query.split(";")) {
        if ($(".c-var ." + value + "-is-visible").is(":visible")) {
            active = true;
        }
    }

    return active;
}

const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

const scrollbarWidth = getScrollbarWidth()

function freezeScroll() {
    beforeFreezeScrollPosition = $(window).scrollTop();

    if (document.body.scrollHeight > window.innerHeight) {
        $('body').css('paddingRight', `${scrollbarWidth}px`);
    }

    $('html, body').addClass('freeze-page');
}

function unfreezeScroll() {
    $('html, body').removeClass('freeze-page');
    $(window).scrollTop(beforeFreezeScrollPosition);
    $('body').css('paddingRight', '');
}

$(".modal").on("show.bs.modal", function() {
    setTimeout(() => {
        freezeScroll();
    }, 0);
});

$(".modal").on("shown.bs.modal", function() {
    if (typeof bLazy === 'object') {
        bLazy.revalidate();

        setTimeout(function() {
            bLazy.revalidate();
        }, 250);
    }
});

$(".modal").on("hide.bs.modal", function() {
    modalBodyPadding = parseInt($('body').css('padding-right'));
});

$(".modal").on("hidden.bs.modal", function() {
    if (modalBodyPadding > 0) {
        $('body').css('padding-right', modalBodyPadding);
        modalBodyPadding = 0;
    }

    unfreezeScroll();

    setTimeout(() => {
        $('body').css('padding-right', '');
    }, 1);
});

function toggleElem(object) {
    if (object.active) {
        hideElem(object);
    } else {
        showElem(object);
    }
}

function showElem(object) {
    if (!object.keepActive && activeElement && activeElement.active) {
        hideElem(activeElement);
    }

    object.trigger.addClass('is-active');
    object.elem.addClass('is-active');

    if (object.name == 'nav' && checkResolution('sm;md;lg')) {
        if ($('.js-trigger-subnav.is-active').length == 0) {
            $('.js-trigger-subnav:first-child').addClass('is-active');
            $('.js-content-subnav:first-child').addClass('is-active');
        }
    }

    if (object.overlay) {
        showOverlay(250, object.allowScroll);
    }

    if (object.callback && object.callback.show) {
        object.callback.show();
    }

    object.active = true;

    activeElement = object;
}

function hideElem(object) {
    object.trigger.removeClass('is-active');
    object.elem.removeClass('is-active');

    if (object.overlay) {
        hideOverlay();
    }

    if (object.callback && object.callback.hide) {
        object.callback.hide();
    }

    object.active = false;
}

function initTippy(theme, options) {
    if (typeof options === 'undefined') {
        options = {};
    }

    $('.js-tippy-' + theme).each(function() {
        if (typeof this._tippy !== 'undefined') {
            this._tippy.destroy();
        }
    });

    $('.js-tippy-' + theme).each(function() {
        const placement = $(this).data('placement');

        tippy(this, $.extend(
            {
                arrow: true,
                theme: theme,
                dynamicTitle: true,
                animation: 'shift-away',
                duration: [300, 180],
                inertia: true,
                performance: true
            },
            options,
            {
                placement: placement
            }
        ));
    });
}

function createTippy() {
    initTippy('thumb-action', {
        placement: 'top-end',
        arrow: false,
        animateFill: false
    });
    initTippy('account-action', {
        placement: 'top-end',
        arrow: false,
        animateFill: false
    });
    initTippy('black');
}

function renderMultiselect() {
    $('.js-multiselect').not('.is-loaded').multiselect({
        templates: {
            button: `
                <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                    <i aria-hidden="true" class="ico ico-caret-down"></i>
                    <span class="multiselect-selected-text"></span>
                </button>
            `
        },
        buttonClass: 'c-btn',
        enableHTML: true
    });

    $('.js-price-offers-multiselect').each(function() {
        var $multiselect = $(this),
            customButtonClass = $multiselect.data('btn-class'),
            filterPlaceholder = $multiselect.data('filter-placeholder'),
            hideEmpty = $multiselect.data('hide-empty'),
            options = {
                templates: {
                    button: `
                        <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                            <i aria-hidden="true" class="ico ico-caret-down"></i>
                            <span class="multiselect-selected-text"></span>
                        </button>
                    `,
                    filter: `
                        <li class="multiselect-item filter">
                            <div class="input-group">
                                <input class="c-form__input is-sm multiselect-search" type="text">
                            </div>
                        </li>
                    `,
                    filterClearBtn: ''
                },
                buttonClass: 'c-btn ' + customButtonClass,
                enableHTML: true,
                enableFiltering: true,
                enableCaseInsensitiveFiltering: true,
                filterPlaceholder: filterPlaceholder || 'Hľadať'
            };

        if (hideEmpty) {
            options.onDropdownShow = function(event) {
                $(event.target).find('input[type="radio"]').filter(function() {
                    return !this.value;
                }).closest('li').hide();
            }
        }

        $multiselect.not('.is-loaded').multiselect(options);

        $multiselect.addClass('is-loaded');
    });

    $('.js-multiselect').addClass('is-loaded');
}

if ($('.l-header').length) {
    RshopApp.$mount('.l-header');
}

rEvent.on('FavoritProduct.added', function() {
    createTippy();
});

rEvent.on('Listing.fetchedData', function (data) {
    createTippy();
});

function calculateViewportUnits() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const header = document.querySelector('.l-header')

    if (!header) {
        return
    }

    const combinedHeight = header.offsetHeight

    document.documentElement.style.setProperty('--header-height', `${combinedHeight}px`)
}

calculateViewportUnits();

function checkCustomerType() {
    const $toggle = $('.js-form-reg [type="checkbox"][name="custom_customer_type_toggle"]'),
        $content = $('.customer-group'),
        $input = $content.find('.c-form__input');

    if ($toggle.is(':checked')) {
        $content.slideDown();
    } else {
        $content.slideUp();
        $input.val('');
    }
}

function checkNotificationType(elem) {
    var $price_input = $('.watchdog_price'),
        isCheaper = $(elem).val() == "become_cheaper";

    if (isCheaper) {
        $price_input.slideDown();
    } else {
        $price_input.slideUp();
    }
}

function watchdogModalLoaded($modal) {
    $modal.addClass('is-loaded');

    $('.js-form-modal-watchdog').validate({
        rules: {
            notification_price: {
                number: true
            }
        },
        submitHandler: function (form) {
            $modal.find('[type="submit"]').prop('disabled', true).addClass('is-loading');
            $('.js-watchdog-error').slideUp(100);
            $('.js-watchdog-success').slideUp(100);

            Form.ajaxPost(form, function (data) {
                $modal.find('[type="submit"]').prop('disabled', false).removeClass('is-loading');

                if (!data.status) {
                    $('.js-watchdog-error')
                        .text(data.message)
                        .slideDown(200);
                } else {
                    $('.js-watchdog-success')
                        .text(data.message)
                        .slideDown(200);
                    $('.js-watchdog-hide').slideUp(200);
                }
            }, 'json');
        }
    });

    checkNotificationType($('#notification_type'));

    $('#notification_type').on('change', function () {
        checkNotificationType($(this));
    });
}

$(function() {
    calculateViewportUnits();

    createTippy();

    setTimeout(function() {
        bLazy.revalidate();
    }, 250);

    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            rEvent.dispatch('Window.resized');

            bLazy.revalidate();
        }, 250);

        calculateViewportUnits();
    });

    $(window).on('scroll', function(e) {
        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(function() {
            rEvent.dispatch('Window.doneScrolling');
            calculateViewportUnits();
        }, 250);
    });

    if ($('.rcrumbs').length > 0) {
        $('.rcrumbs').rcrumbs({
            ellipsis: true,
            nbUncollapsableCrumbs: 1,
            nbFixedCrumbs: 1,
            animation: {
                activated: false
            }
        });
    }

    // shorten
    $(".js-shorten").each(function() {
        const $elem = $(this),
            count = $elem.data("count"),
            more = $elem.data("more-text"),
            less = $elem.data("less-text");

        $elem.shorten({
            showChars: count,
            ellipsesText: "...",
            moreText: more,
            lessText: less
        });
    });

    $('.js-remote-modal').on('hidden.bs.modal', function() {
        $(this).removeClass('is-loaded');
    });

    renderMultiselect();

    $('.js-price-demand-form').validate({
        errorPlacement: function (error, element) {
            if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            $('.js-price-demand-submit')
                .prop('disabled', true)
                .addClass('is-loading');

            form.submit();
        }
    });

    $('body').on('click', '.pager__item a', function () {
        $(this).closest('.listing').slideHere(60);
    });

    $(window).on('popstate', () => {
        // console.log('popstate')
        if (!document.querySelector('.listing')) {
            return
        }

        // ? -> https://github.com/whatwg/html/issues/1042
        history.replaceState({scrollTop: document.body.scrollTop}, '', window.location);
        $('.listing').slideHere(60);
    });

    $(document).on('click', '.js-confirm-link', function(e) {
        const $link = $(this),
            title = $(this).data('title'),
            confirmText = $(this).data('confirm'),
            cancelText = $(this).data('cancel');

        e.preventDefault();

        Eshop.confirm(title, {
            confirmButtonText: confirmText,
            cancelButtonText: cancelText
        }, function() {
            window.location.href = $link.prop('href');
        });
    });


    checkCustomerType();

    $('.l-base').on('change', '[type="checkbox"][name="custom_customer_type_toggle"]', function() {
        checkCustomerType();
    });

    $('.js-remote-modal').on('hidden.bs.modal', function() {
        $(this).removeClass('is-loaded');
    });

    $(document).on('click', '.js-visualization-delete', function (event) {
        const url = $(this).attr('href'),
            $elem = $(this),
            confirmTitle = $elem.data('message') ? $elem.data('message') : 'Skutočne chcete odstrániť túto vizualizáciu z košíka?',
            confirmText = $elem.data('text') ? $elem.data('text') : '';

        event.preventDefault();

        Eshop.confirm(confirmTitle, { text: confirmText }, function () {
            if ($elem.parents('.minicart').length > 0) {
                $.ajax({
                    url: url,
                    success: function() {
                        store.dispatch('fetchCart');
                    },
                    error: function() {
                        console.log('bundle nebol odstraneny');
                    }
                });
            }
            else {
                window.location = url;
            }
        });
    });

    $(document).on('click', '.js-toggle-password', function () {
        const $this = $(this),
            $input = $this.parent().find('.c-form__input');

        $input.attr('type', $input.attr('type') == 'text' ? 'password' : 'text');
    });

    $(".js-msg-text .c-btn").bind("click", function(event){
        event.preventDefault();

        setCookie("msg-text", $('.js-msg-text').attr('data-value'), 1);

        $(".js-msg-text").slideUp();
    });

    $(".js-msg-nav .c-btn").bind("click", function(event){
        const id = $(this).parents('.js-msg-nav').attr('data-id');

        event.preventDefault();

        setCookie('msg-nav-' + id, $(this).parents('.js-msg-nav').attr('data-value'), 1);

        $('.js-msg-nav[data-id="' + id + '"]').slideUp();
    });
});


/**
 * Share url
 */
$(function() {
    $('.js-share-current-url').on('click', async function() {
        const shareData = {
            title: document.querySelector('meta[property="og:title"]').content,
            url: window.location.href,
        }

        try {
            await navigator.share(shareData)
        } catch (err) {
            if (err && err.name === 'AbortError') {
                return
            }

            try {
                // copy url to clipboard if share is not supported
                await navigator.clipboard.writeText(shareData.url)

                Eshop.alert($(this).data('success'))
            } catch (err) {
                Eshop.alert(
                    $(this).data('error'),
                    { type: 'error' }
                )
            }
        }
    });

    $('.js-appointment-modal-form').on('submit', function(e) {
        e.preventDefault();
    });

    $("#appointment-modal").on("hidden.bs.modal", function() {
        $('.js-appointment-modal').show();
        $('.js-appointment-modal-success').hide();
    });

    $('.js-appointment-modal-form').validate({
        errorPlacement: function (error, element) {
            if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            const $form = $(form)

            $form.find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            /*Form.ajaxPost(form, function (data) {
                $form.find('[type="submit"]').prop('disabled', false).removeClass('is-loading');

                console.log(data);

                if (!data.status) {
                    Eshop.alert(data.message, {
                        type: 'error'
                    });
                } else {
                    $form.find('[type="checkbox"]').prop('checked', false);
                    $form.find('[name="email_or_phone"]').val('');

                    $('.js-appointment-modal').hide();
                    $('.js-appointment-modal-success').show();
                }

                $form.find('[type="submit"]').prop('disabled', false).removeClass('is-loading');
            }, 'json');*/

            $.post($form.attr('action'), $form.serialize(), function (response) {
                $form.find('[type="submit"]').prop('disabled', false).removeClass('is-loading');

                console.log(response);

                if (!response.status) {
                    Eshop.alert(response.message, {
                        type: 'error'
                    });

                    return
                }

                $form.find('[type="checkbox"]').prop('checked', false);
                $form.find('[name="email_or_phone"]').val('');

                $('.js-appointment-modal').hide();
                $('.js-appointment-modal-success').show();
            }, 'json').fail(function (err) {
                Eshop.alert(err.statusText, {
                    type: 'error'
                });

                $form.find('[type="submit"]').prop('disabled', false).removeClass('is-loading');
            });
        }
    });
});
